import {Form, Input, Modal, message} from "antd";
import {useEffect, useState} from "react";
import useIsMobile from "../../utils/mediaQuery";
import "./ExportDwgAssets.css";

const ExportDwgAssetsModal = ({isOpen, setOpen, handleDownload}) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const isMobile = useIsMobile();
  const [refreshKey, setRefreshKey] = useState(0);

  const forceRefresh = () => {
    setRefreshKey((prev) => prev + 1); // Increment the counter to trigger re-render
  };

  useEffect(() => {
    window.refreshAssetAddKey = forceRefresh

    // Cleanup to avoid leaking the global
    return () => {
      delete window.refreshAssetAddKey;
    };
  }, []);

  const handleConfirm = async () => {
    try {
      const {espg, scale} = await form.validateFields();
      setLoading(true);
      const data = {
        espg: espg,
        scale: scale
      }
      console.log(data)
      await handleDownload(espg, scale)
        .catch((err) => {console.error(err)})
        .finally(() => {
          setLoading(false);
          form.resetFields();
          setOpen(false);
        });
    } catch (errorInfo) {
      // Validation failed - errorInfo contains the validation errors
      console.log('Validation failed:', errorInfo);
    }
  }

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  }

  return (
    <Modal
      refreshKey={refreshKey}
      open={isOpen}
      title={"Export Dwg Assets"}
      okText={isLoading ? 'Exporting...' : 'Export'}
      onCancel={handleCancel}
      onOk={handleConfirm}
      centered
      okButtonProps={{ loading: isLoading }}
      wrapClassName="export-dwg-modal"
      styles={{
        body: {
          overflow: 'hidden',
        },
        header: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 16,
          paddingTop: 15,
          fontWeight: 600,
          fontSize: 18,
        },
        footer: {
          display: 'flex',
          justifyContent: 'end',
          gap: 16,
          alignItems: 'center',
          padding: 8,
        },
      }}
    >
      <Form form={form} layout="vertical" style={{
        padding: 16,
      }}>
        <Form.Item
          label="EPSG"
          name="espg"
          rules={[{
            required: true,
            message: "The EPSG is required"
          }]}>
          <Input placeholder="e.g. '28992' for RD New / '3857' for Web Mercator"/>
        </Form.Item>
        <Form.Item
          label="Scale"
          name="scale"
          rules={[
            {
              required: true,
              message: "The scale is required"
            },
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.resolve();
                }
                const numValue = parseFloat(value);
                if (isNaN(numValue)) {
                  return Promise.reject(new Error("Scale must be a number"));
                }
                if (numValue <= 0.5 || numValue >= 5) {
                  return Promise.reject(new Error("The scale must be higher than 0.5 and lower than 5"));
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <Input type="number" step="0.1" placeholder="Scale" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ExportDwgAssetsModal;